export const setLayoutFooter = (state,footername) => {
    state.layoutPrincipal.footer = footername
}
export const setLayoutNav = (state, navname) => {
    state.layoutPrincipal.navBar = navname
}